var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"artists-related section"},[_c('h2',[_vm._v(_vm._s(_vm.$t('artistsEvent.artistas')))]),_c('div',{staticClass:"separator"}),_c('slider',{attrs:{"type":'artist',"elements":_vm.artistsEvent}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }